module.exports = __webpack_public_path__ + "img/suguilong-1.c9fb911a.jpg";